import React from "react";
import { FormattedMessage } from "react-intl";

interface NoResultsProps {
    style: React.CSSProperties;
    className: string;
}

export const NoResults = ({ className, style }: NoResultsProps) => (
    <div style={style} className={className}>
        <FormattedMessage id="ui.select.no_results" defaultMessage="No results found" />
    </div>
);
